import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { MarketingFeaturesPage } from '#marketing/components/MarketingFeaturesPage.jsx';

/** @param {{ matches: Array<{ id?: string, pathname?: string, data?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'features', pagePath: '/features' });
}

export default function Features() {
  return <MarketingFeaturesPage />;
}
